import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "18",
  height: "2",
  viewBox: "0 0 18 2",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<path d=\"M1 0.25C0.585786 0.25 0.25 0.585786 0.25 1C0.25 1.41421 0.585786 1.75 1 1.75H17C17.4142 1.75 17.75 1.41421 17.75 1C17.75 0.585786 17.4142 0.25 17 0.25H1Z\" fill=\"url(#paint0_linear_3136_2821)\"></path><defs><linearGradient id=\"paint0_linear_3136_2821\" x1=\"-8.48708\" y1=\"0.998892\" x2=\"-8.23219\" y2=\"3.97261\" gradientUnits=\"userSpaceOnUse\"><stop stop-color=\"#00FFAA\"></stop><stop offset=\"0.517251\" stop-color=\"#4579F5\"></stop><stop offset=\"0.999815\" stop-color=\"#9C42F5\"></stop></linearGradient></defs>", 2)
  ]))]))
}